const actors = {
  enbridge: 'Enbridge',
};

const button = {
  cancel: 'Annuler',
  confirm: 'Confirmer',
  create: 'Créer',
  save: 'Enregister',
};

const entity = {
  client: 'Client',
  mission: 'Mission',
  report: 'Rapport',
  dictionary: 'Dictionnaire',
};

const message = {
  error: {
    global: 'Une erreur est survenue. Veuillez essayer de nouveau.',
    signalr: 'Une erreur est survenue avec SignalR',
  },
  errorWithSystem: 'Il y a eu une erreur avec ce système:',
  pageNotFound: "Cette page n'a pu être trouvée",
  requiredField: 'Champ requis',
  success: {
    deleted: '$t(common.entity.{{entity}}) supprimé(e) avec succès',
    downloaded: '$t(common.entity.{{entity}}) téléchargé(e) avec succès',
    uploaded: '$t(common.entity.{{entity}}) chargé(e) avec succès',
    copiedToClipboard: 'Copié dans le presse-papier avec succès!',
  },
  technicalSupport: "Veuillez contacter votre support technique pour obtenir de l'aide.",
};

const menu = {
  navigationBar: {
    clients: 'Clients',
    missions: 'Missions',
    reports: 'Rapports',
  },
};

const userInterface = {
  noDataToDisplay: 'Aucune donnée à afficher',
  noModificationsToSave: 'Aucune modifications à enregistrer',
  unsavedModifications: 'Veuillez enregister vos modifications',
};

export default {
  actors,
  button,
  entity,
  menu,
  message,
  no: 'Non',
  search: 'Rechercher...',
  userInterface,
  yes: 'Oui',
};
